var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormatStrikethroughOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 11H5C4.45614 11 4 11.4561 4 12C4 12.5439 4.45614 13 5 13H19C19.5439 13 20 12.5439 20 12C20 11.4561 19.5439 11 19 11ZM16.7719 6.36842C15.5789 4.92982 13.8772 4 12 4C9.2807 4 7 5.96491 7 8.49123C7 9.03509 7.45614 9.49123 8 9.49123C8.54386 9.49123 9 9.03509 9 8.49123C9 7.01754 10.1579 6 12 6C13.3158 6 14.3333 6.5614 15.2281 7.63158C15.4211 7.85965 15.6842 8 16 8C16.5439 8 17 7.54386 17 7C17 6.75439 16.9123 6.54386 16.7719 6.36842ZM15 15.4912C15 16.9825 13.8421 18 12 18C10.6842 18 9.66667 17.4386 8.77193 16.3684C8.57895 16.1404 8.31579 16 8 16C7.45614 16 7 16.4561 7 17C7 17.2456 7.08772 17.4561 7.22807 17.6316C8.42105 19.0702 10.1228 20 12 20C14.7193 20 17 18.0351 17 15.4912C17 14.9474 16.5439 14.4912 16 14.4912C15.4561 14.4912 15 14.9474 15 15.4912Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatStrikethroughOutlined);
export default __webpack_public_path__ + "static/media/format_strikethrough_outlined.fc95f8d3.svg";
export { ForwardRef as ReactComponent };